import { post } from "@/services/axiosUitils";
import { NavUserDetailsResponse } from "@/utils/types/NavUserDetils";

const base = "/nps/cra/scheme-nav-details/";

class NavUserDetailsService {
  getNavUserDetails = async (
    fromDate: string,
    toDate: string,
    schemeId: string,
    getNavExcel: string
  ): Promise<NavUserDetailsResponse> => {
    const payload = {
      fromDate,
      toDate,
      schemeId,
      getNavExcel,
    };
    return await post<NavUserDetailsResponse>(base, payload);
  };
}

const instance = new NavUserDetailsService();
export default instance;
